import Vue from 'vue';
import CurrencyFilterModel from 'Models/CurrencyFilterModel';

export default class CurrencyFilterField {
  constructor(fieldId, fieldData = null) {
    this.field = Vue.observable(CurrencyFilterField.getBaseFieldById(fieldId));
    this.fieldData = fieldData;

    this._populateField(fieldData);

    return this;
  }

  setValue(event) {
    this.field.value = event;
  }

  search(search) {
    let parsedItems = [];

    if (!this.fieldData.has_custom_value) {
      parsedItems = this.fieldData.product_currency_setting_field_values
        ?.map((item) => ({
          id: item.id,
          value: item.value,
          image: item.additional_value,
          priority: item.priority,
        }))
        ?.sort((a, b) => b.priority - a.priority);
    } else if (this.fieldData.component_view_data?.values) {
      parsedItems = this.fieldData.component_view_data.values
        ?.map((item) => ({
          value: item.title,
          min: item.min,
          max: item.max,
        }));
    }

    if (search === '') {
      this.field.props.searchResults = [...parsedItems];
      return;
    }

    this.field.props.searchResults = parsedItems
      .filter((item) => item.value.toLowerCase().includes(search.toLowerCase()));
  }

  _populateField(fieldData) {
    if (!fieldData) {
      return;
    }

    this._populateProps(fieldData);

    if (fieldData.default_value !== undefined) {
      try {
        this.setValue(this.field.prepareValue(fieldData.default_value, fieldData));
      } catch (e) {
        CurrencyFilterField.throwError('prepareValue function was not found in the field');
      }
    }
  }

  _populateProps(fieldData) {
    this.field._propValues = this.field.prepareProps(fieldData);

    const fieldProps = Object.keys(this.field.props);

    if (fieldProps?.length) {
      fieldProps.forEach((propKey) => {
        if (propKey in this.field._propValues) {
          this.field.props[propKey] = this.field._propValues[propKey];
        } else if (this.field.props[propKey] === undefined) {
          CurrencyFilterField.throwError(
            `required key fieldData._propValues.${propKey} was not found in 
             fieldData._propValues=${JSON.stringify(fieldData._props)}`,
          );
        }
      });
    }
  }

  // eslint-disable-next-line consistent-return
  static getBaseFieldById(fieldId) {
    try {
      return CurrencyFilterModel.FIELD_BY_ID[fieldId]();
    } catch (e) {
      CurrencyFilterField.throwError(`base field not found for id=${fieldId}`);
    }
  }

  static throwError(message) {
    throw new Error(`CurrencyFilterField: ${message}`);
  }
}
